import { useInfiniteQuery, keepPreviousData } from "@tanstack/react-query";
import { ApiTable } from "@/shared/api/table/api-table";
import { isDataPreparingError } from "@/shared/lib/apiErrorHandler";

const PAGE_LIMIT = 500;
// Каталог ещё собирается (503 DATA_PREPARING): опрос раз в 30 с, как в Retry-After
// шлюза, и не дольше ~30 мин; три повтора подряд ничего не изменят.
const PREPARING_POLL_MS = 30_000;
const PREPARING_MAX_POLLS = 60;

export const useNmsInfiniteQuery = (
  supplierId: string | undefined,
  searchQuery: string,
) => {
  const tableApi = new ApiTable();

  return useInfiniteQuery({
    queryKey: ["nms", supplierId, searchQuery],
    queryFn: async ({ pageParam = 0 }) => {
      const response = await tableApi.getNms(supplierId!, {
        q: searchQuery || null,
        limit: PAGE_LIMIT,
        offset: pageParam as number,
      });
      return response.data;
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      const loaded = allPages.reduce((acc, p) => acc + p.data.length, 0);
      if (loaded >= lastPage.total) return undefined;
      return loaded;
    },
    enabled: !!supplierId,
    staleTime: 1000 * 60 * 2,
    retry: (failureCount, error) =>
      !isDataPreparingError(error) && failureCount < 3,
    refetchInterval: (query) =>
      isDataPreparingError(query.state.error) &&
      query.state.errorUpdateCount <= PREPARING_MAX_POLLS
        ? PREPARING_POLL_MS
        : false,
    placeholderData: keepPreviousData,
  });
};
